const topCntnt = (() => {
  const pageTop = (document.getElementById("pageTop") != null);
  if (pageTop) {



    const secCntnt = document.querySelector('#jsSecCntnt');
    const cntntWrps = secCntnt.querySelectorAll('.js-cntnt-wrp');


    cntntWrps.forEach((element, index) => {

      let tl = gsap.timeline({
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: element,
          start: '0% 50%',
          end: '100% 50%',
          onEnter: () => {
            element.classList.add('act')
          },
          onEnterBack: () => {
            element.classList.add('act')
          },
          onLeave: () => {
            element.classList.remove('act')
          },
          onLeaveBack: () => {
            element.classList.remove('act')
          },
          // markers: true,
        },
      })

      let target = document.querySelector('body');
      let observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          tl.scrollTrigger.refresh()
        });
      });
      observer.observe(target);

    });



  }
})()
export default topCntnt;